export default function ErrorPage() {
  return (
    <div style={{ padding: '40px', textAlign: 'center' }}>
      <h1>404 - Page Not Found</h1>
      <p>The page you're looking for doesn't exist.</p>
      <a
        href="/"
        style={{
          display: 'inline-block',
          padding: '10px 20px',
          fontSize: '16px',
          backgroundColor: '#007bff',
          color: 'white',
          textDecoration: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
        }}
      >
        Go Home
      </a>
    </div>
  );
}
